import { render, staticRenderFns } from "./Step2TravelAgent.vue?vue&type=template&id=4c394e8e"
import script from "./Step2TravelAgent.vue?vue&type=script&lang=js"
export * from "./Step2TravelAgent.vue?vue&type=script&lang=js"
import style0 from "./Step2TravelAgent.vue?vue&type=style&index=0&id=4c394e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports